// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana Process Types
 * Auto-generated input/output schemas for every Rana process tag. Do not edit manually.
 *
 * The version of the OpenAPI document: generated
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { RanaFile } from "./RanaFile";
import {
  RanaFileFromJSON,
  RanaFileFromJSONTyped,
  RanaFileToJSON,
  RanaFileToJSONTyped,
} from "./RanaFile";
import type { FileFeatureSelector } from "./FileFeatureSelector";
import {
  FileFeatureSelectorFromJSON,
  FileFeatureSelectorFromJSONTyped,
  FileFeatureSelectorToJSON,
  FileFeatureSelectorToJSONTyped,
} from "./FileFeatureSelector";

/**
 *
 * @export
 * @interface CustomFileInput
 */
export interface CustomFileInput {
  /**
   *
   */
  selection: FileFeatureSelector;
  /**
   *
   */
  fileBoundary: RanaFile;
}

/**
 * Check if a given object implements the CustomFileInput interface.
 */
export function instanceOfCustomFileInput(value: object): value is CustomFileInput {
  if (!("selection" in value) || value["selection"] === undefined) return false;
  if (
    (!("fileBoundary" in (value as Record<string, any>)) &&
      !("file_boundary" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["fileBoundary"] === undefined &&
      (value as Record<string, any>)["file_boundary"] === undefined)
  )
    return false;
  return true;
}

export function CustomFileInputFromJSON(json: any): CustomFileInput {
  return CustomFileInputFromJSONTyped(json, false);
}

export function CustomFileInputFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): CustomFileInput {
  if (json == null) {
    return json;
  }
  return {
    selection: FileFeatureSelectorFromJSON(json["selection"]),
    fileBoundary: RanaFileFromJSON(json["file_boundary"]),
  };
}

export function CustomFileInputToJSON(json: any): CustomFileInput {
  return CustomFileInputToJSONTyped(json, false);
}

export function CustomFileInputToJSONTyped(
  value?: CustomFileInput | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    selection: FileFeatureSelectorToJSON(value["selection"]),
    file_boundary: RanaFileToJSON(value["fileBoundary"]),
  };
}
